/** 
 * api接口统一管理
 */
import { post, postform, postoctetstream } from './axios';


/**
 * 
 * @param {string} params 
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */
const link = '/otherusedcar'
// const link = ''

// 新增鉴价车辆
export const reqAddContactUs = params => post(`${link}/contactUs/addContactUs`, params)

// 查询品牌
export const reqGetBrandsList = params => post(`${link}/car/getBrands`, params)

// 查询车系+车型列表（鉴价服务中的车型选择列表）
export const reqGetCarSeriesAndModels = params => post(`${link}/car/getCarSeriesAndModels`, params)

// 新增鉴价车辆
export const reqAddValuationCar = params => post(`${link}/newValuation/addValuationCar`, params)

// 查询车款列表
export const reqGetCarStyleList = params => postform(`${link}/car/getCarStyleList`, params)

// 查询轮播图列表
export const reqBanners = params => post(`${link}/banner/getBanners`, params)

//获取库存列表
export const reqGetCarInventoryList = params => post(`${link}/carInventory/getCarInventoryList`, params)

// 下载
export const reqDownLoadPdf = params => postoctetstream(`${link}/carInventory/downLoadPdf`, params)


// WEBPACK FOOTER //
// ./src/untils/api.js